import { LogTypeEnum } from '../../_enums/logtype.enum';

export class LoggerMessageModel {
  Id: number;
  Message: string;
  Type: LogTypeEnum;
};
